import { render, staticRenderFns } from "./AssignSupervisorAccess.vue?vue&type=template&id=674becb6"
import script from "./AssignSupervisorAccess.vue?vue&type=script&lang=js"
export * from "./AssignSupervisorAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports